export const WidgetRoutes = {
  Widgets: "/cheet/widgets",
  CreateWidget: "/cheet/widgets/create",
  WidgetDetail: "/cheet/widgets/:id/details",
  Widget: "/cheet/widgets/:id",
} as const;
